import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { parseString } from 'xml2js';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import ExerciseInterface from './ExerciseInterface';
import InteractionInterface from '../services/InteractionInterface';
import * as actions from '../actions';

class App extends Component {
	constructor(props) {
		super(props);
		this.version = null;
	}

	componentDidMount() {
		const { loaderAppElement, loaderExternalInterface, setInteractionInterface, setBasePath } = this.props;
		new window.loader.exercises.common.ConfigurationDelegateCallback(this.dataLoaded.bind(this)).load(`${this.props.base}aareadparagraph.xml`);
		this.setupTestHandlers();
		setBasePath(this.props.base);
		setInteractionInterface(
			new InteractionInterface(
				loaderAppElement,
				loaderExternalInterface,
				this.props.store
			)
		);
	}

	setupTestHandlers() {
		const { testMode, loaderAppElement, setTestSent, restartExercise, setTestMode, setExContainer } = this.props;
		if (testMode) {
			const exContainer = window.nl_loader.getExContainerByChild(loaderAppElement);
			// console.log(exContainer);
			setTestMode(testMode);
			setExContainer(exContainer);
			window.nl_loader.getTestAdmin().hideButtons(exContainer);

			switch (testMode) {
				case 'exam': {
					window.nl_loader.getTestAdmin().setCheckAnswersHandler(exContainer, setTestSent);
					if (window.NL_CONFIG.debugTest) {
						window.nl_loader.getTestAdmin().setRestartHandler(exContainer, restartExercise);
					}
					break;
				}
				default:
			}
		}
	}

	dataLoaded(xml, res) {
		const {
			onDataLoaded,
			setVersion,
			setItems,
			processItems,
			interaction,
			loaderExternalInterface,
			setAudioEnabled,
			setAudioPrefix
		} = this.props;

		parseString(res.responseText, { explicitCharkey: true }, (err, result) => {
			if (err) window.alert(`parseString error: ${err.message}`);

			onDataLoaded(result);

			const attrs = result.AaReadParagraph.$ || {};
			setVersion(attrs.version ? attrs.version : 1);

			setItems(result.AaReadParagraph.item);

			setAudioPrefix(attrs.audioPrefix || '');
			setAudioEnabled(attrs.audio === 'true');

			if (interaction) {
				interaction.recover();
			}

			processItems();

			loaderExternalInterface.appLoaded = true;
		});
	}

	render() {
		const { exerciseReady } = this.props;

		if (!exerciseReady) {
			return (
				<div>Loading...</div>
			);
		}

		return <ExerciseInterface />;
	}
}

App.propTypes = {
	processItems: PropTypes.func.isRequired,
	loaderAppElement: PropTypes.object.isRequired, // eslint-disable-line react/no-unused-prop-types
	loaderExternalInterface: PropTypes.object.isRequired,
	base: PropTypes.string.isRequired,
	setInteractionInterface: PropTypes.func.isRequired,
	setVersion: PropTypes.func.isRequired,
	setItems: PropTypes.func.isRequired,
	setTestMode: PropTypes.func.isRequired,
	setExContainer: PropTypes.func.isRequired,
	setTestSent: PropTypes.func.isRequired,
	restartExercise: PropTypes.func.isRequired,
	setBasePath: PropTypes.func.isRequired,
	interaction: PropTypes.object,
	testMode: PropTypes.string,
	exContainer: PropTypes.object,
	exerciseReady: PropTypes.bool.isRequired,
	onDataLoaded: PropTypes.func,
	setAudioPrefix: PropTypes.func.isRequired,
	setAudioEnabled: PropTypes.func.isRequired,
	store: PropTypes.object.isRequired
};

App.defaultProps = {
	interaction: null,
	testMode: undefined,
	exContainer: undefined,
	onDataLoaded: () => { },
};

const mapStateToProps = ({ exercise: { exerciseReady }, loader }) => ({
	exerciseReady,
	interaction: loader.interaction,
	exContainer: loader.exContainer
});

export default compose(
	connect(mapStateToProps, actions)
)(App);
